import { AddressDetails, DEFAULT_ADDRESS_DETAILS } from '../../shared/models/address.types';
import { ContactDetails, DEFAULT_CONTACT_PHONE } from '../../shared/models/contact.types';

export type PosProfile = 'HV POS' | 'Standard POS' | 'Dealer POS';
export type PosStatus = 'active' | 'inactive';
export type PosStockStatus = 'ok' | 'low' | 'out-of-stock';

export interface PosStockDetails {
  stockOnHand: number;
  reorderLevel: number;
  stockStatus: PosStockStatus;
  lastStockUpdate: string;
  notes: string;
  entries: PosStockEntry[];
}

export interface PosStockEntry {
  id: string;
  dateTime: string;
  agent: string;
  productAsset: string;
  quantity: number;
  entryStatus: string;
  remarks: string;
  proofRef?: string;
  balanceAfter?: number;
}

export interface PosUpsertPayload {
  name: string;
  profile: PosProfile;
  status: PosStatus;
  contact: ContactDetails;
  address: AddressDetails;
  stockDetails: PosStockDetails;
}

export interface PosModel {
  id: string;
  name: string;
  code?: string;
  profile: PosProfile;
  status: PosStatus;
  stockStatus: PosStockStatus;
  entityType: 'External POS';
  primaryAgent?: string;
  primaryAgency?: string;
  lastVisitDate?: string;
  contact: ContactDetails;
  contactPhoneDisplay: string;
  address: AddressDetails;
  city: string;
  area: string;
  stockDetails: PosStockDetails;
  stockOnHandDisplay: string;
}

export interface PosRecord extends PosModel {}

export const DEFAULT_POS_PROFILE: PosProfile = 'Standard POS';
export const DEFAULT_POS_STATUS: PosStatus = 'active';
export const DEFAULT_POS_STOCK_DETAILS: PosStockDetails = {
  stockOnHand: 0,
  reorderLevel: 0,
  stockStatus: 'ok',
  lastStockUpdate: '',
  notes: '',
  entries: []
};

export const DEFAULT_POS_ADDRESS = DEFAULT_ADDRESS_DETAILS;
export const DEFAULT_POS_PHONE = DEFAULT_CONTACT_PHONE;

export function toPosRecord(id: string, payload: PosUpsertPayload, current?: PosRecord): PosRecord {
  return {
    id: current?.id ?? id,
    name: payload.name,
    profile: payload.profile,
    status: payload.status,
    stockStatus: payload.stockDetails.stockStatus,
    entityType: 'External POS',
    contact: payload.contact,
    contactPhoneDisplay: formatPosPhoneDisplay(payload.contact),
    address: payload.address,
    city: payload.address.locality,
    area: payload.address.area,
    stockDetails: payload.stockDetails,
    stockOnHandDisplay: `${payload.stockDetails.stockOnHand} units`
  };
}

export function formatPosPhoneDisplay(contact: ContactDetails): string {
  const dialCode = contact.phone.dialCode ? `+${contact.phone.dialCode}` : '';
  return [dialCode, contact.phone.number].filter(Boolean).join(' ').trim() || 'Not provided';
}
